import React from 'react';

const CodeTagsIcon = (props) => (
  <svg width='32' height='32' viewBox='0 0 32 32' {...props}>
    <g fill='currentColor' fillRule='nonzero'>
      <g transform='translate(6.000000, 10.000000)'>
        <path d='M12.6,10.6 L17.2,6 L12.6,1.4 L14,0 L20,6 L14,12 L12.6,10.6 M7.4,10.6 L2.8,6 L7.4,1.4 L6,0 L0,6 L6,12 L7.4,10.6 Z' />
      </g>
    </g>
  </svg>
);

export default CodeTagsIcon;
